export default __webpack_public_path__ + "static/media/dessert3.fe612dd3.jpg";